<script setup lang="ts">
import { KsButton, KsDrawer, KsInput } from '@aschehoug/kloss'
import { useAuthStore } from '../../stores/auth'
import { PreferredLanguage } from '../../models/User/PreferredLanguage'
import { useI18n } from 'vue-i18n'
import { TeleportationTarget } from '~/models/TeleportationTarget'

const props = defineProps<{
  open: boolean
}>()

const { t } = useI18n()
const authStore = useAuthStore()

const {
  isPreferredLanguage,
  setPreferredLanguage,
} = authStore

const emit = defineEmits(['back', 'close'])

</script>

<template>
  <Teleport :to="TeleportationTarget.AppTop">
    <KsDrawer
      :title="t('settings.drawers.language')"
      :open="props.open"
      :backdrop="false"
      size="600px"
      @close="emit('close')"
    >
      <template #header>
        <KsButton
          shape="round"
          icon-left="arrow-left"
          :aria-label="t('back')"
          :title="t('back')"
          @click="emit('back')"
        />
      </template>
      <template #body>
        <div class="flex flex-col gap-6 border-t border-gray-10 py-6">
          <form>
            <fieldset class="flex gap-3">
              <legend
                class="mb-2 text-base font-medium uppercase tracking-wide text-gray-40"
                v-text="t('filters.chooseLanguage')"
              />
              <KsButton
                variant="secondary"
                shape="rounded"
                type="label"
              >
                <KsInput
                  :value="PreferredLanguage.Bokmal"
                  type="radio"
                  :checked="isPreferredLanguage(PreferredLanguage.Bokmal)"
                  @click="setPreferredLanguage(PreferredLanguage.Bokmal)"
                />
                {{ t(`metadata.language.${PreferredLanguage.Bokmal}`) }}
              </KsButton>
              <KsButton
                variant="secondary"
                shape="rounded"
                type="label"
              >
                <KsInput
                  :value="PreferredLanguage.Nynorsk"
                  type="radio"
                  :checked="isPreferredLanguage(PreferredLanguage.Nynorsk)"
                  @click="setPreferredLanguage(PreferredLanguage.Nynorsk)"
                />
                {{ t(`metadata.language.${PreferredLanguage.Nynorsk}`) }}
              </KsButton>
            </fieldset>
          </form>
        </div>
      </template>
    </KsDrawer>
  </Teleport>
</template>
